// src/app/SellingPoints.tsx
import classNames from "classnames";
import React, { useMemo } from "react";

import { useTranslations } from "@/context/TranslationsContext";

const SellingPoints: React.FC = () => {
  const { t, direction } = useTranslations();
  const isRTL = direction === "rtl";

  const sellingPoints = useMemo(
    () => [
      t("sellingPoints.point1"),
      t("sellingPoints.point2"),
      t("sellingPoints.point3"),
      t("sellingPoints.point4"),
      t("sellingPoints.point5"),
      t("sellingPoints.point6"),
    ],
    [t],
  );

  const totalDuration = sellingPoints.length * 3;

  return (
    <div className="mb-6 relative w-full h-[50px] overflow-hidden">
      {sellingPoints.map((point, idx) => (
        <p
          key={idx}
          className={classNames(
            "absolute inset-0 flex items-center justify-center text-lg sm:text-xl font-semibold text-[#ececec] opacity-0",
            {
              "text-right": isRTL,
              "text-left": !isRTL,
            },
          )}
          style={{
            animation: `slideFade ${totalDuration}s infinite`,
            animationDelay: `${idx * 3}s`,
          }}
        >
          {point}
        </p>
      ))}

      <style jsx>{`
        @keyframes slideFade {
          0% {
            opacity: 0;
            transform: translateY(100%);
          }
          8.333% {
            opacity: 1;
            transform: translateY(0);
          }
          16.666% {
            opacity: 1;
            transform: translateY(0);
          }
          25% {
            opacity: 0;
            transform: translateY(-100%);
          }
          100% {
            opacity: 0;
            transform: translateY(-100%);
          }
        }
      `}</style>
    </div>
  );
};

export default SellingPoints;
